import instance from "../redux/actions/AxiosInstance/authenticated";

export const fetchSettings = async () => {
    try {
      const response = await instance.get("/user/settings");
      // console.log("Settings:", response.data);
  
      return response?.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  export const fetchUserDetails = async () => {
    try {
      const response = await instance.get("/verifyUser");
  
      return response?.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  export const updateSettings = async (data) => {
    try {
      const response = await instance.post("/user/settings", data);
  
      return response?.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };
  